<canvas
  class="size-full"
  baseChart
  [data]="doughnutChartData"
  [type]="'doughnut'"
  [options]="doughnutChartOptions"
>
</canvas>
